import './App.css';
import {Routes, Route} from 'react-router-dom'
import Home from './Home/Home';
import ContainerWebApp from './StackDocumentation/ContainerWebApp/ContainerWebApp';
import EventDrivenNotification from './StackDocumentation/EventDrivenNotification/EventDrivenNotification';
import ServerlessApi from './StackDocumentation/ServerlessApi/ServerlessApi';
import StaticWebsite from './StackDocumentation/StaticWebsite/StaticWebsite';
import CustomVpc from './StackDocumentation/CustomVpc/CustomVpc';
import TransitGateway from './StackDocumentation/TransitGateway/TransitGateway';


const App = () => {
  return (
    <Routes>
      <Route index element={<Home/>}/>
      <Route path='/ContainerWebApp' element={<ContainerWebApp/>} />
      <Route path="/EventDrivenNotifications" element={<EventDrivenNotification/>}/>
      <Route path="/ServerlessApi" element={<ServerlessApi />}/>
      <Route path="/StaticWebsite" element={<StaticWebsite />}/>
      <Route path="/CustomVpc" element={<CustomVpc />}/>
      <Route path="/TransitGateway" element={<TransitGateway/>}/>
    </Routes>
  );
}

export default App;
